import React, { useContext, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { useHistory } from "react-router-dom";
import TextField from "@/component/widgets/text-field";
import SelectField from "@/component/widgets/select-field";
import TextareaField from "@/component/widgets/textarea-field";
import { appRepo } from "@/repo/app-repo";
import { useTicketsRedirect } from "../use-tickets-redirect";

export default function CreateTicketPage() {
    var ticketsEnabled = useTicketsRedirect();
    const { setNotification } = useContext<AppContextType>(WonmovContext);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [priority, setPriority] = useState<"low" | "medium" | "high" | "critical" | undefined>(undefined);
    const [description, setDescription] = useState("");
    const history = useHistory();

    const handleSubmit = async () => {
        if (isLoading) return;
        if (!title) {
            setNotification({ type: "danger", message: "عنوان تیکت را وارد کنید" });
            return;
        }
        if (!description) {
            setNotification({ type: "danger", message: "توضیحات تیکت را وارد کنید" });
            return;
        }
        if (!priority) {
            setNotification({ type: "danger", message: "اولویت تیکت را انتخاب کنید" });
            return;
        }
        setIsLoading(true);
        const res = await appRepo.createTicket(title.trim(), priority, description.trim());
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            setIsLoading(false);
            return;
        }
        setNotification({ type: "success", message: "تیکت با موفقیت ایجاد شد" });
        setIsLoading(false);
        history.replace("/profile/tickets/");
    }

    if (!ticketsEnabled) {
        return null;
    }

    return (
        <div className="w-full rounded-xl bg-bg2 p-4 flex flex-col gap-4">
            <h2 className="text-2xl font-bold text-white">ایجاد تیکت جدید</h2>

            <div className="w-full flex flex-col md:flex-row gap-4">
                <TextField
                    name="title"
                    value={title}
                    placeholder="عنوان تیکت"
                    onChange={(e) => setTitle(e.target.value)}
                />
                <SelectField
                    uniqueKey="priority"
                    value={priority || ""}
                    options={[
                        { label: "انتخاب اولویت", value: "" },
                        { label: "کم", value: "low" },
                        { label: "متوسط", value: "medium" },
                        { label: "زیاد", value: "high" },
                        { label: "بسیار زیاد", value: "critical" },
                    ]}
                    onChange={(value) => setPriority(value as "low" | "medium" | "high" | "critical")}
                />
            </div>

            <TextareaField
                name="description"
                value={description}
                placeholder="توضیحات تیکت"
                onChange={(e) => setDescription(e.target.value)}
            />

            <button
                className="w-full md:w-auto flex items-center justify-center py-3 cursor-pointer rounded-xl bg-lime-400 px-4 text-sm font-semibold text-zinc-900 transition hover:bg-lime-300"
                onClick={handleSubmit}
            >
                {isLoading ? <div className="loader"></div> : "ایجاد تیکت"}
            </button>
        </div>
    );
}